<template>
  <div>
  </div>
</template>

<script>

import Breadcrumb from '@/components/common/Breadcrumb';

export default {
  components: {
    Breadcrumb
  }
};
</script>

<style>

</style>
